import React from 'react';
import LeftFlowers from 'assets/onboarding/flowers_left.svg';
import RightFlowers from 'assets/onboarding/flowers_right.svg';
import CreoQuiz1 from 'assets/onboarding/creo_quiz_1.svg';
import CreoQuiz2 from 'assets/onboarding/creo_quiz_2.svg';
import CreoQuiz3 from 'assets/onboarding/creo_quiz_3.svg';
import CreoQuiz4 from 'assets/onboarding/creo_quiz_4.svg';
import { QuestionComponentProps } from '../QuestionComponent.types';
import { useCreoQuizComponentLogic } from './CreoQuizQuestion.hook';
import { QuestionIds } from 'onboarding/data/constants/QuestionIds';
import { CustomQuestion } from '../Question';
import styles from './styles.module.scss';

type Props = QuestionComponentProps<CustomQuestion>;

const CREO_QUIZ_IMAGES_MAP: Record<string, string> = {
  [QuestionIds.CreoQuizQ1]: CreoQuiz1,
  [QuestionIds.CreoQuizQ2]: CreoQuiz2,
  [QuestionIds.CreoQuizQ3]: CreoQuiz3,
  [QuestionIds.CreoQuizQ4]: CreoQuiz4,
};

const CREO_QUIZ_BUTTON_LABEL_MAP: Record<
  string,
  { label1: string; label2: string }
> = {
  [QuestionIds.CreoQuizQ1]: { label1: 'Hare', label2: 'Bird' },
  [QuestionIds.CreoQuizQ2]: { label1: 'Forest', label2: 'Elephant' },
  [QuestionIds.CreoQuizQ3]: { label1: 'Hands', label2: 'Guitar' },
  [QuestionIds.CreoQuizQ4]: { label1: 'Squirrel', label2: 'Swan' },
};

export const CreoQuizComponent: React.FC<Props> = React.memo(({ question }) => {
  const { containerStyle, nextHandler } = useCreoQuizComponentLogic(question);
  const { label1, label2 } = CREO_QUIZ_BUTTON_LABEL_MAP[question.id];
  const imageSrc = CREO_QUIZ_IMAGES_MAP[question.id];

  return (
    <div
      className={`${styles.container} ${styles[containerStyle]} ${styles.speed}`}
    >
      <div className={styles.fog} />

      <div className={styles.innerContainer}>
        <div className={styles.background}>
          <h2 className={styles.title}>ANXIETY TEST</h2>
          <p className={styles.description}>What do you see first?</p>
          <img src={imageSrc} alt="Quiz visual" />
        </div>

        <div className={styles.buttonsWrapper}>
          {[label1, label2].map((label) => (
            <button
              key={label}
              className={styles.button}
              onClick={(e) => nextHandler(e, label)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      <div className={styles.bottom}>
        <img src={LeftFlowers} alt="" />
        <img src={RightFlowers} alt="" />
      </div>
    </div>
  );
});
